<!-- RightButtons.vue -->
<template>
  <!-- 同一DOMを teleport で移動。先が無い時は自動無効化 -->
  <teleport :to="teleportTargetEl" :disabled="!teleporting || !teleportTargetEl">
    <!-- 右側：基本アイコン列（isSmall500 && isDraw の時、またはiframeの時は非表示） -->
    <div v-if="!(isSmall500 && isDraw) && !isIframe" class="d-flex flex-column icons-div-base" :style="{ pointerEvents: isFreehandCanvasActive ? 'none' : 'auto', opacity: isFreehandCanvasActive ? 0.3 : 1 }" @mousedown.stop @touchstart.stop>
      <template v-for="b in btnsNorm" :key="b.key">
        <!-- ツールボックスボタンはドロップダウンメニュー -->
        <template v-if="b.key === 'toolbox'">
          <v-menu offset-x :close-on-content-click="true">
            <template v-slot:activator="{ props }">
              <MiniTooltip :text="b.text" :offset-x="0" :offset-y="0">
                <v-btn
                    icon
                    :size="isSmall500 ? 'small' : 'default'"
                    v-bind="props"
                >
                  <v-icon>{{ b.icon }}</v-icon>
                </v-btn>
              </MiniTooltip>
            </template>
            <v-list density="compact" class="draw-tool-menu">
              <v-list-item v-track="'toolbox-elevation-profile'" @click="onElevationProfile">
                <template v-slot:prepend>
                  <v-icon>mdi-chart-line-variant</v-icon>
                </template>
                <v-list-item-title>断面図</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-magnify'" @click="onMagnifyToggle">
                <template v-slot:prepend>
                  <v-icon :color="isMagnifying ? '#4caf50' : undefined">
                    {{ isMagnifying ? 'mdi-magnify-close' : 'mdi-magnify-plus-outline' }}
                  </v-icon>
                </template>
                <v-list-item-title>{{ isMagnifying ? '虫眼鏡を閉じる' : '虫眼鏡' }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-mono-mode'" @click="onMonoModeToggle">
                <template v-slot:prepend>
                  <v-icon :color="isSketchMode ? '#4caf50' : undefined">mdi-invert-colors-off</v-icon>
                </template>
                <v-list-item-title>{{ isSketchMode ? 'モノクロ解除' : 'モノクロ' }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-spatial-query'" @click="onSpatialQuery">
                <template v-slot:prepend>
                  <v-icon>mdi-filter-variant</v-icon>
                </template>
                <v-list-item-title>空間クエリ</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-sima-quick'" @click="onSimaQuick">
                <template v-slot:prepend>
                  <v-icon>mdi-map-marker-plus</v-icon>
                </template>
                <v-list-item-title>簡単SIMA</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-isochrone'" @click="onIsochrone">
                <template v-slot:prepend>
                  <v-icon>mdi-map-marker-radius</v-icon>
                </template>
                <v-list-item-title>到達圏</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-ai-watershed'" @click="onWatershed">
                <template v-slot:prepend>
                  <v-icon>mdi-water</v-icon>
                </template>
                <v-list-item-title>流域計算</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-jusetsu-draft'" @click="onJusetsuDraft">
                <template v-slot:prepend>
                  <v-icon>mdi-clipboard-text</v-icon>
                </template>
                <v-list-item-title>重説補助資料作成</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-maisoku'" @click="onMaisoku">
                <template v-slot:prepend>
                  <v-icon>mdi-file-image-outline</v-icon>
                </template>
                <v-list-item-title><span style="color: #C62828; font-weight: bold;">NEW</span> 簡易マイソク</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-property-report'" @click="onPropertyReport">
                <template v-slot:prepend>
                  <v-icon>mdi-home-search</v-icon>
                </template>
                <v-list-item-title>AI物件調査レポート</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-multi-point-ranking'" @click="onMultiPointRanking">
                <template v-slot:prepend>
                  <v-icon>mdi-home-plus</v-icon>
                </template>
                <v-list-item-title><span style="color: #e74c3c; font-weight: bold;">NEW</span> AI物件調査レポート+</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-ai-childcare-report'" @click="onChildCareReport">
                <template v-slot:prepend>
                  <v-icon>mdi-baby-carriage</v-icon>
                </template>
                <v-list-item-title>AI子育てレポート</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-area-analysis'" @click="onAreaAnalysis">
                <template v-slot:prepend>
                  <v-icon>mdi-vector-polygon</v-icon>
                </template>
                <v-list-item-title>AI防災リスク診断</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-super-population'" @click="onSuperPopulation">
                <template v-slot:prepend>
                  <v-icon>mdi-chart-bar-stacked</v-icon>
                </template>
                <v-list-item-title>AI人口プロファイル</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-ai-map-chat'" @click="onAiMapCompare">
                <template v-slot:prepend>
                  <v-icon>mdi-chat-processing</v-icon>
                </template>
                <v-list-item-title>AI地図チャット</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-ai-osm-search'" @click="onAiOsmSearch">
                <template v-slot:prepend>
                  <v-icon>mdi-magnify-scan</v-icon>
                </template>
                <v-list-item-title>AI OSM検索</v-list-item-title>
              </v-list-item>
              <!-- AI瞬間レポート（一時的にコメントアウト）
              <v-list-item v-track="'toolbox-ai-point-info'" @click="onAiPointInfo">
                <template v-slot:prepend>
                  <v-icon>mdi-map-marker-question</v-icon>
                </template>
                <v-list-item-title>AI瞬間レポート</v-list-item-title>
              </v-list-item>
              -->
              <v-list-item v-track="'toolbox-fs-investigation'" @click="onFsInvestigation">
                <template v-slot:prepend>
                  <v-icon>mdi-city-variant-outline</v-icon>
                </template>
                <v-list-item-title>土地法規等調査</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-super-cross-section'" @click="onSuperCrossSection">
                <template v-slot:prepend>
                  <v-icon>mdi-layers-search</v-icon>
                </template>
                <v-list-item-title>超串刺し抽出</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-ai-enhance'" @click="onAiEnhance" :disabled="aiEnhanceProcessing">
                <template v-slot:prepend>
                  <v-icon>{{ aiEnhanceProcessing ? 'mdi-loading mdi-spin' : 'mdi-auto-fix' }}</v-icon>
                </template>
                <v-list-item-title>{{ aiEnhanceProcessing ? 'AI画像鮮明化中...' : 'AI画像鮮明化' }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-upload'" @click="onUpload">
                <template v-slot:prepend>
                  <v-icon>mdi-upload</v-icon>
                </template>
                <v-list-item-title>各種アップロード</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-hillshade'" @click="onHillshadeSettings">
                <template v-slot:prepend>
                  <v-icon>mdi-image-filter-hdr</v-icon>
                </template>
                <v-list-item-title>陰影設定</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-spreadsheet-sync'" @click="onSpreadsheetSync">
                <template v-slot:prepend>
                  <v-icon :color="spreadsheetSyncRunning ? 'success' : undefined">
                    {{ spreadsheetSyncRunning ? 'mdi-sync' : 'mdi-google-spreadsheet' }}
                  </v-icon>
                </template>
                <v-list-item-title>
                  <span v-if="spreadsheetSyncRunning" style="color: #22c55e;">同期中</span>
                  <span v-else>スプレッドシート同期</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-top100'" @click="onPopularLayers">
                <template v-slot:prepend>
                  <v-icon>mdi-chart-line</v-icon>
                </template>
                <v-list-item-title>人気レイヤー TOP 100</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-swipe'" @click="onSwipeCompare">
                <template v-slot:prepend>
                  <v-icon>mdi-compare</v-icon>
                </template>
                <v-list-item-title>スワイプ比較</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-timeslider'" @click="onTimeSlider">
                <template v-slot:prepend>
                  <v-icon>mdi-clock-outline</v-icon>
                </template>
                <v-list-item-title>今昔タイムスライダー</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-offline-area'" @click="onOfflineAreaManager">
                <template v-slot:prepend>
                  <v-icon>mdi-cloud-download</v-icon>
                </template>
                <v-list-item-title>オフラインエリア管理</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-group-chat'" @click="onGroupManage">
                <template v-slot:prepend>
                  <v-icon>mdi-account-group</v-icon>
                </template>
                <v-list-item-title>グループチャット</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'toolbox-gallery'" @click="onGallery">
                <template v-slot:prepend>
                  <v-icon>mdi-image-multiple</v-icon>
                </template>
                <v-list-item-title>ギャラリー</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <!-- 現在地ボタンはドロップダウンメニュー -->
        <template v-else-if="b.key === 'location'">
          <v-menu offset-x :close-on-content-click="true">
            <template v-slot:activator="{ props }">
              <MiniTooltip :text="b.text" :offset-x="0" :offset-y="0">
                <v-btn
                    icon
                    :size="isSmall500 ? 'small' : 'default'"
                    v-bind="props"
                    :color="isWatching ? 'success' : undefined"
                >
                  <v-icon>{{ isWatching ? 'mdi-map-marker-radius' : b.icon }}</v-icon>
                </v-btn>
              </MiniTooltip>
            </template>
            <v-list density="compact" class="draw-tool-menu">
              <v-list-item v-track="'location-once'" @click="onLocateOnce">
                <template v-slot:prepend>
                  <v-icon>mdi-crosshairs-gps</v-icon>
                </template>
                <v-list-item-title>現在地取得</v-list-item-title>
              </v-list-item>
              <v-list-item v-track="'location-watch'" @click="onWatchToggle" :class="{ 'item-active': isWatching }">
                <template v-slot:prepend>
                  <v-icon>mdi-map-marker-radius</v-icon>
                </template>
                <v-list-item-title>{{ isWatching ? '連続取得を停止' : '現在地連続取得' }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <!-- ヘルプボタンはドロップダウンメニュー -->
        <template v-else-if="b.key === 'help'">
          <v-menu offset-x :close-on-content-click="true">
            <template v-slot:activator="{ props }">
              <MiniTooltip :text="b.text" :offset-x="0" :offset-y="0">
                <v-btn
                    icon
                    :size="isSmall500 ? 'small' : 'default'"
                    v-bind="props"
                >
                  <v-icon>{{ b.icon }}</v-icon>
                </v-btn>
              </MiniTooltip>
            </template>
            <v-list density="compact" class="draw-tool-menu">
              <!-- ランディングページ -->
              <v-list-item v-track="'help-lp'" href="https://kenzkenz.jp/oh3/lp.html" target="_blank">
                <template v-slot:prepend>
                  <v-icon color="info">mdi-web</v-icon>
                </template>
                <v-list-item-title>OH3について</v-list-item-title>
              </v-list-item>
              <!-- ヘルプ -->
              <v-list-item v-track="'help-about'" @click="onAboutOH3">
                <template v-slot:prepend>
                  <v-icon>mdi-book-open-page-variant</v-icon>
                </template>
                <v-list-item-title>ヘルプ</v-list-item-title>
              </v-list-item>
              <!-- AIヘルプ -->
              <v-list-item v-track="'help-ai'" @click="onAiHelp">
                <template v-slot:prepend>
                  <v-icon color="primary">mdi-robot-happy-outline</v-icon>
                </template>
                <v-list-item-title>AIヘルプ</v-list-item-title>
              </v-list-item>
              <!-- 逆引き辞典 -->
              <v-list-item v-track="'help-external'" @click="onHelpExternal">
                <template v-slot:prepend>
                  <v-icon>mdi-swap-horizontal</v-icon>
                </template>
                <v-list-item-title>逆引き辞典</v-list-item-title>
              </v-list-item>
              <!-- ご意見・不具合報告 -->
              <v-list-item v-track="'help-feedback'" href="https://forms.gle/iD4x6y59Gftf8U7n8" target="_blank">
                <template v-slot:prepend>
                  <v-icon color="success">mdi-form-select</v-icon>
                </template>
                <v-list-item-title>ご意見・不具合報告</v-list-item-title>
              </v-list-item>
              <!-- プラン -->
              <v-list-item v-track="'help-plan'" @click="onOpenPlan">
                <template v-slot:prepend>
                  <v-icon color="primary">mdi-star</v-icon>
                </template>
                <v-list-item-title>プラン</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <!-- その他のボタン -->
        <template v-else>
          <MiniTooltip :text="b.text" :offset-x="0" :offset-y="0">
            <v-btn
                icon
                :id="b.key === 'draw' ? 'draw-mode-btn' : undefined"
                :size="isSmall500 ? 'small' : 'default'"
                :style="b.style || ''"
                :loading="b.key === 'pdf' && pdfLoading"
                :disabled="(typeof b.disabled === 'function' ? !!b.disabled(ctx) : !!b.disabled) || (b.key === 'pdf' && pdfLoading)"
                @click="typeof b.method==='string'
                      ? ($options.methods?.[b.method] && $options.methods[b.method].call(this, b))
                      : (typeof b.method==='function' && b.method.call(this, b))"
            >
              <v-icon v-if="b.icon">{{ b.icon }}</v-icon>
              <span v-else>{{ b.label }}</span>
            </v-btn>
          </MiniTooltip>
        </template>
      </template>
    </div>

    <!--
      ドロー状態ステータス（トップ中央）
      親 #map01 の oh-map-motion--active 時に filter が適用されると
      CSS containing block が作られ position:fixed が map01 基準になって
      上下に跳ねる現象が起きる。body 直下に Teleport して回避する。
    -->
    <Teleport to="body">
      <div v-if="drawStatusLabel && !isPrint" class="draw-status-pill" :style="{ background: 'var(--oh3-color-white)' }">
        <span class="status-dot"></span>
        <span>{{ drawStatusLabel }}</span>
      </div>
    </Teleport>

    <!-- 左隣：描画ツール列（描画モード時のみ）。isSmall500 && isDraw の時は right:10px に寄せる -->
    <div v-if="isDraw" class="d-flex flex-column icons2-div-base" :style="icons2Style">
      <!-- グループ1: 描画ツール -->
      <v-menu offset-x :close-on-content-click="true">
        <template v-slot:activator="{ props }">
          <MiniTooltip text="描画ツール" :offset-x="0" :offset-y="0">
            <v-btn icon color="primary" size="small" v-bind="props" @click="closeDrawUIOnToolSwitch">
              <v-icon>mdi-draw</v-icon>
            </v-btn>
          </MiniTooltip>
        </template>
        <v-list density="compact" class="draw-tool-menu">
          <v-list-item v-track="'draw-tool-freehand-canvas'" @click="onToggleFreehandCanvas">
            <template v-slot:prepend>
              <v-icon>mdi-pencil</v-icon>
            </template>
            <v-list-item-title>スケッチ</v-list-item-title>
          </v-list-item>
          <v-list-item v-track="'draw-tool-text'" @click="onToggleDrawText" :class="{ 'item-active': isDrawText }">
            <template v-slot:prepend>
              <v-icon>mdi-format-text</v-icon>
            </template>
            <v-list-item-title>テキスト</v-list-item-title>
          </v-list-item>
          <v-list-item v-track="'draw-tool-point'" @click="onToggleDrawPoint" :class="{ 'item-active': isDrawPoint }">
            <template v-slot:prepend>
              <v-icon>mdi-map-marker</v-icon>
            </template>
            <v-list-item-title>点</v-list-item-title>
          </v-list-item>
          <v-list-item v-track="'draw-tool-circle'" @click="onToggleDrawCircle" :class="{ 'item-active': isDrawCircle }">
            <template v-slot:prepend>
              <v-icon>mdi-circle-outline</v-icon>
            </template>
            <v-list-item-title>円</v-list-item-title>
          </v-list-item>
          <v-list-item v-track="'draw-tool-line'" @click="onToggleLDrawLine" :class="{ 'item-active': isDrawLine }">
            <template v-slot:prepend>
              <v-icon>mdi-vector-line</v-icon>
            </template>
            <v-list-item-title>線</v-list-item-title>
          </v-list-item>
          <v-list-item v-track="'draw-tool-polygon'" @click="onToggleLDrawPolygon" :class="{ 'item-active': isDrawPolygon }">
            <template v-slot:prepend>
              <v-icon>mdi-vector-polygon</v-icon>
            </template>
            <v-list-item-title>多角形</v-list-item-title>
          </v-list-item>
          <!-- GPS写真追加は一旦非表示（フィールドノートに統合）
          <v-list-item v-track="'draw-tool-gps-photo'" @click="onGpsPhotoImport">
            <template v-slot:prepend>
              <v-icon>mdi-map-marker-multiple</v-icon>
            </template>
            <v-list-item-title>GPS写真追加</v-list-item-title>
          </v-list-item>
          -->
          <v-list-item v-track="'draw-tool-photo-memo'" @click="onPhotoMemo">
            <template v-slot:prepend>
              <v-icon>mdi-camera-plus</v-icon>
            </template>
            <v-list-item-title>フィールドノート</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- 投げ縄ボタン -->
      <MiniTooltip text="投げ縄" :offset-x="0" :offset-y="0">
        <v-btn v-track="'draw-tool-lasso'" icon size="small" @click="onToggleDrawLasso" :color="isDrawLasso ? 'success' : 'primary'">
          <v-icon>mdi-lasso</v-icon>
        </v-btn>
      </MiniTooltip>

      <!-- 全削除ボタン -->
      <MiniTooltip text="全削除" :offset-x="0" :offset-y="0">
        <v-btn v-track="'draw-tool-delete-all'" icon size="small" @click="onDeleteAllForDraw" color="primary">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </MiniTooltip>

      <!-- ドローリストボタン -->
      <MiniTooltip text="ドローリスト" :offset-x="0" :offset-y="0">
        <v-btn icon size="small" @click="onDrawListOpen" color="primary">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
      </MiniTooltip>

      <!-- グループ3: 履歴（グループチャット中・投げ縄中は操作不可・バッジ非表示） -->
      <MiniTooltip :text="undoRedoDisabledReason || (canUndo ? `元に戻す (残り${undoCount}回)` : '元に戻す (履歴なし)')" :offset-x="0" :offset-y="0">
        <v-badge :content="undoCount" :model-value="undoCount > 0 && !disableUndoRedo" color="blue-grey" offset-x="8" offset-y="8">
          <v-btn icon color="primary" size="small" @click="onUndo" :disabled="!canUndo || disableUndoRedo">
            <v-icon>mdi-undo</v-icon>
          </v-btn>
        </v-badge>
      </MiniTooltip>
      <MiniTooltip :text="undoRedoDisabledReason || (canRedo ? `やり直す (残り${redoCount}回)` : 'やり直す (履歴なし)')" :offset-x="0" :offset-y="0">
        <v-badge :content="redoCount" :model-value="redoCount > 0 && !disableUndoRedo" color="blue-grey" offset-x="8" offset-y="8">
          <v-btn icon color="primary" size="small" @click="onRedo" :disabled="!canRedo || disableUndoRedo">
            <v-icon>mdi-redo</v-icon>
          </v-btn>
        </v-badge>
      </MiniTooltip>

      <!-- マイドローボタン（独立） グループ共有ドロー時は操作不可 -->
      <MiniTooltip :text="isGroupDraw ? 'グループチャット中は操作できません' : 'マイドロー'" :offset-x="0" :offset-y="0">
        <v-btn v-track="'draw-tool-cloud'" icon color="primary" size="small" @click="onDrawShare" :disabled="isGroupDraw">
          <v-icon>mdi-cloud</v-icon>
        </v-btn>
      </MiniTooltip>

      <!-- ダウンロードボタン -->
      <MiniTooltip text="ダウンロード" :offset-x="0" :offset-y="0">
        <v-btn v-track="'draw-tool-download'" icon color="primary" size="small" @click="onDialogForDlOpen">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </MiniTooltip>

      <!-- ヘルプボタン(独立) -->
      <MiniTooltip text="ヘルプ" :offset-x="0" :offset-y="0">
        <v-btn icon color="primary" size="small" @click="onDrawHelp">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </MiniTooltip>

      <!-- 閉じるボタン(独立) -->
      <MiniTooltip text="閉じる" :offset-x="0" :offset-y="0">
        <v-btn icon color="grey" size="small" @click="onDrawClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </MiniTooltip>
    </div>
  </teleport>

  <!-- GPS写真インポート用の非表示ファイル入力 -->
  <input
    ref="gpsPhotoInput"
    type="file"
    accept="image/*,.heic,.heif"
    multiple
    class="d-none"
    @change="onGpsPhotoSelected"
  />

  <!-- GPS写真インポートエラーダイアログ -->
  <MessageDialog
    ref="gpsPhotoErrorDialog"
    v-model="gpsPhotoErrorDialogOpen"
    :title="gpsPhotoErrorTitle"
    :content-html="gpsPhotoErrorMessage"
    :max-width="600"
    :icon="'mdi-alert-circle'"
    :icon-color="'warning'"
    :show-close-icon="true"
    :show-title-divider="true"
  />

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MiniTooltip from '@/components/MiniTooltip.vue'
import MessageDialog from '@/components/Message-Dialog.vue'
import { closeAllPopups } from '@/js/popup'
import { getUsageTracker } from '@/js/utils/usageTracker'
import { clearSelectedFeature } from '@/js/draw'
import { requireLogin } from '@/js/utils/messageHelper'
import spreadsheetSyncManager from '@/js/spreadsheetSyncManager'
import { consumeToken, getTokenBalance } from '@/js/tokenService'

export default {
  name: 'RightButtons',
  components: { MiniTooltip, MessageDialog },
  props: {
    /** 表示プリセット 'default' | 'minimal' | 'field' | 'readonly' */
    flag: { type: String, default: 'default' },
    /** 親のメソッド群（emit不要で直呼び） */
    handlers: { type: Object, default: () => ({}) },
    /** 2画面モードフラグ */
    isMap2Mode: { type: Boolean, default: false }
  },
  data () {
    return {
      ctx: { self: this },
      buttons: [],

      // Teleport
      teleporting: false,
      teleportTargetSel: '.v-application',  // Vuetifyの<v-app>ルート
      teleportTargetEl: null,                // セレクタ解決した Element を保持（未解決時は body）

      // Usage Tracker
      usageTracker: null,

      // GPS Photo Error Dialog
      gpsPhotoErrorDialogOpen: false,
      gpsPhotoErrorTitle: '',
      gpsPhotoErrorMessage: '',
    }
  },
  created () {
    this.applyFlag(this.flag)

    // 利用度トラッキング初期化
    try {
      this.usageTracker = getUsageTracker(undefined, this.$store)
    } catch (error) {
      console.warn('[RightButtons] Failed to initialize usage tracker:', error)
    }
  },
  mounted () {
    // 初回解決を関数に統一
    this.ensureTeleportTarget()
  },
  watch: {
    flag (v) { this.applyFlag(v) },
    // isDraw が切り替わったら default プリセットのみ再構成（ドローリストの有無を反映）
    // ただし印刷モード時は右DIVを変更しない
    isDraw () {
      if (this.flag === 'default' && !this.isPrint) {
        this.setButtonsDefault()
      }
    },
    // isPrint が切り替わったら右DIVを印刷設定 or デフォルトに
    isPrint (value) {
      if (value) {
        this.setButtonsPrint()
      } else {
        this.setButtonsDefault()
      }
    }
  },
  computed: {
    ...mapState([
      'isSmall500',
      'map01',
      'isDraw',
      'isPrint',
      'isIframe',
      'is4ScreenMode',
      'tgtFeature',
      'selectedLayers',
      'isNetworkOffline',
      'showDrawListDrawer',
      // 描画系のON/OFF表示に使用（色の切替）
      'isDrawPoint',
      'isDrawCircle',
      'isDrawLine',
      'isDrawPolygon',
      'isDrawFree',
      'isDrawLasso',
      'isLassoSelected',
      'isDrawText',
      'editEnabled',
      'drawVisible',
      'userId',
      'geojsonId',
      'geojsonName',
      'isUsingServerGeojson',
      'isEditable',
      'isWatching',
      'isMagnifying',
      'isSketchMode',
      'pdfLoading',
      'aiEnhanceProcessing',
      'aiEnhanceSaving',
      'isOverseas',
    ]),
    ...mapGetters([
      'canUndo',
      'canRedo',
      'undoCount',
      'redoCount',
      'historyInfo'
    ]),
    spreadsheetSyncRunning() {
      return spreadsheetSyncManager.isRunning
    },
    // グループ共有ドロー（グループチャット用）かどうか
    isGroupDraw() {
      return (this.$store.state.geojsonName || '').startsWith('グループ共有_')
    },
    disableUndoRedo() {
      // グループドロー、投げ縄モード中は無効化（マイドローではundo/redo可能）
      return this.isGroupDraw || this.isDrawLasso || this.isLassoSelected
    },
    // アンドゥ/リドゥ無効化の理由（ツールチップ用）
    undoRedoDisabledReason() {
      if (this.isDrawLasso || this.isLassoSelected) return '投げ縄中は操作不可'
      if (this.isGroupDraw) return 'グループドロー中は操作不可'
      return null
    },
    // スケッチモードがアクティブかどうか
    isFreehandCanvasActive() {
      return this.$store.state.isFreehandCanvasActive
    },
    canCreateElevation() {
      // tgtFeatureが存在し、LineStringまたはMultiLineStringである場合のみ有効
      if (!this.tgtFeature || !this.tgtFeature.geometry) return false
      const geomType = this.tgtFeature.geometry.type
      return geomType === 'LineString' || geomType === 'MultiLineString'
    },
    btnsNorm () {
      return this.buttons
        .filter(b => {
          // isSmall500 のときは印刷ボタンを非表示
          if (b.key === 'print' && this.isSmall500) return false
          // 4画面モードのときは印刷、ヘルプ、情報を非表示（共有、現在地は表示する）
          if (this.is4ScreenMode && ['print', 'help', 'about'].includes(b.key)) return false
          // スマホ時 & PC状態でない場合はヘルプ・情報を非表示
          if (this.isSmall500 && !this.$store.state.showPcMode && ['help', 'about'].includes(b.key)) return false
          return true
        })
        .map(b => ({
          key: b.key,
          text: b.text ?? '',
          icon: b.icon,
          label: b.label,
          style: b.style,
          method: b.method,               // 子メソッド名 or 関数
          disabled: b.disabled ?? false,  // bool or (ctx)=>bool
          payload: b.payload
        }))
    },
    drawBtns () {
      return [
        { key:'point',   text:'点、画像',   label:'点',   color: this.isDrawPoint   ? 'green' : 'blue',  method:'onToggleDrawPoint', style:'font-size:20px;' },
        { key:'circle',  text:'円',         label:'円',   color: this.isDrawCircle  ? 'green' : 'blue',  method:'onToggleDrawCircle', style:'font-size:20px;' },
        { key:'line',    text:'線',         label:'線',   color: this.isDrawLine    ? 'green' : 'blue',  method:'onToggleLDrawLine', style:'font-size:20px;' },
        { key:'polygon', text:'多角形',     label:'多角', color: this.isDrawPolygon ? 'green' : 'blue',  method:'onToggleLDrawPolygon', style:'font-size:14px;' },
        { key:'free',    text:'自由',       label:'自由', color: this.isDrawFree    ? 'green' : 'blue',  method:'onToggleLDrawFree', style:'font-size:14px;' },
        { key:'lasso',   text:'投げ縄',     label:'投縄',   color: this.isDrawLasso   ? 'green' : 'blue',  method:'onToggleDrawLasso', style:'font-size:14px;' },
        { key:'edit',    text:'変形と移動', label:'編集', color: this.editEnabled   ? 'green' : undefined, method:'onToggleEditEnabled', style:'font-size:14px;' },
        { key:'undo',    text: this.undoRedoDisabledReason || (this.canUndo ? `元に戻す (残り${this.undoCount}回)` : '元に戻す (履歴なし)'),   label:'戻',   icon:'mdi-undo',  disabled: !this.canUndo || this.disableUndoRedo,  method:'onUndo' },
        { key:'redo',    text: this.undoRedoDisabledReason || (this.canRedo ? `やり直す (残り${this.redoCount}回)` : 'やり直す (履歴なし)'),   label:'進',   icon:'mdi-redo',  disabled: !this.canRedo || this.disableUndoRedo,  method:'onRedo' },
        { key:'cloud',   text: this.isGroupDraw ? 'グループチャット中は操作不可' : 'マイドロー', label:'雲',   color:'green', disabled: this.isGroupDraw, method:'onDrawShare', style:'font-size:14px;'},
        { key:'config',  text:'設定',   label:'設定',   color:'blue',                                    method:'onDrawConfig', style:'font-size:14px;'},
        { key:'dl',      text:'DL',         label:'DL',   style:'background-color:navy!important;',        method:'onDialogForDlOpen' },
        { key:'delete',  text:'全削除',     label:'削',   icon:'mdi-delete', color:'error',                method:'onDeleteAllForDraw' },
        { key:'close',   text:'閉じる',     label:'閉',   icon:'mdi-close',  color:'green',                method:'onDrawClose' },
      ]
    },
    drawBtnsNorm () {
      return this.drawBtns.map(d => ({
        key: d.key, text: d.text ?? '', label: d.label ?? '',
        icon: d.icon, color: d.color, style: d.style,
        method: d.method, disabled: d.disabled ?? false, payload: d.payload
      }))
    },
    // ここで左列の right を条件で切替
    // isSmall500 && isDraw の時のみ 10px
    // ドローリストが開いている時（小画面以外）は左に移動（250px + 70px = 320px）
    // ただし、2画面/4画面モードでは移動しない（1画面モードのみ移動）
    icons2Style () {
      // スケッチモード時は操作不可
      const sketchStyle = this.isFreehandCanvasActive
        ? { pointerEvents: 'none', opacity: 0.3 }
        : { pointerEvents: 'auto', opacity: 1 }

      if (this.isSmall500 && this.isDraw) {
        return { right: '10px', ...sketchStyle }
      }
      // ドローリストが開いている時は左に移動（1画面モードのみ）
      // 2画面モード(isMap2Mode)または4画面モード(is4ScreenMode)の時は移動しない
      const isSingleScreenMode = !this.isMap2Mode && !this.is4ScreenMode
      if (this.showDrawListDrawer && isSingleScreenMode) {
        return { right: '280px', ...sketchStyle }
      }
      return { right: '70px', ...sketchStyle }
    },
    drawStatusLabel() {
      if (!this.isDraw) return ''
      // グループ共有ドローの場合は表示しない
      if (this.isGroupDraw) return ''
      if (this.isUsingServerGeojson && this.geojsonId) {
        const editType = this.$store.state.isEditableForVSelect
        let editable = '閲覧のみ'
        if (editType === 'public') {
          editable = '編集可'
        } else if (editType === 'private') {
          editable = '自分だけが閲覧可'
        } else if (editType === 'private-edit') {
          editable = '自分だけが編集可'
        }
        return `サーバードロー: ${this.geojsonName || '名称なし'}（${editable}）`
      }
      return '通常ドロー（ローカル保存）'
    },
    drawStatusColor() {
      if (!this.isDraw) return ''
      const editType = this.$store.state.isEditableForVSelect
      if (this.isUsingServerGeojson && editType === 'public') return 'success'
      if (this.isUsingServerGeojson && editType === 'private') return 'purple'
      if (this.isUsingServerGeojson) return 'info'
      return 'primary'
    }
  },
  methods: {
    /** プリセット適用（右列） */
    applyFlag (flag) {
      switch (flag) {
        case 'minimal':   this.setButtonsMinimal(); break
        case 'field':     this.setButtonsField();   break
        case 'readonly':  this.setButtonsReadonly(); break
        case 'default':
        default:          this.setButtonsDefault(); break
      }
    },

    // ★ デフォルト構成（ドローリストは左列のグループに移動済み）
    setButtonsDefault () {
      this.buttons = [
        // { key:'groupChat', text:'グループチャット', icon:'mdi-account-group', method:'onGroupManage' },
        { key:'print', text:'印刷', icon:'mdi-printer', method:'onPrint' },
        { key:'addressSearch', text:'住所検索', icon:'mdi-map-search', method:'onAddressSearch' },
        { key:'toolbox', text:'ツールボックス', icon:'mdi-tools', method:'onToolbox' },
        { key:'location', text:'現在地', icon:'mdi-crosshairs-gps', method:'onLocation' },
        { key:'share', text:'共有', icon:'mdi-share-variant',     method:'onShare', payload:{ source:'toolbar' } },
        { key:'help',  text:'ヘルプ', icon:'mdi-help-circle-outline',            method:'onHelp' },
        { key:'draw',  text:'ドロー', icon:'mdi-pencil',          method:'onToggleLDraw' },
        { key:'about', text:'情報', icon:'mdi-information-variant', method:'onAbout' },
      ]
    },

    setButtonsPrint () {
      this.buttons = [
        { key:'printBack', text:'戻る',  icon:'mdi-arrow-left',  method:'onPrintBack' },
        { key:'printGo',   text:'印刷',  icon:'mdi-printer',     method:'onPrintExec' },
        { key:'qrcode',    text:'QRコード', icon:'mdi-qrcode',  method:'onQrCode' },
        { key:'config',    text:'設定',  label:'設定',           method:'onPrintConfig', style:'font-size:14px; font-weight:700;' },
        { key:'pdf',       text:'PDF',   label:'PDF',            method:'onPdfDl', style:'font-size:14px; font-weight:700;' },
        { key:'draw',  text:'ドロー', icon:'mdi-pencil',          method:'onToggleLDraw' },
      ]
    },
    setButtonsMinimal () {
      this.buttons = [
        { key:'print', text:'印刷', icon:'mdi-printer', method:'onPrint' },
        { key:'help',  text:'ヘルプ', icon:'mdi-help',  method:'onHelp' },
      ]
    },
    setButtonsField () {
      this.buttons = [
        { key:'location', text:'現在地', icon:'mdi-crosshairs-gps', method:'onLocation' },
        { key:'share', text:'共有', icon:'mdi-share-variant', method:'onShare' },
        { key:'help',  text:'ヘルプ', icon:'mdi-help', method:'onHelp' },
      ]
    },
    setButtonsReadonly () {
      this.buttons = [
        { key:'help', text:'ヘルプ', icon:'mdi-help', method:'onHelp' },
      ]
    },

    // 右列：子メソッド
    onToggleLDraw () {
      this.usageTracker?.trackEvent('button', 'click', 'toggleDraw', { text: 'ドロー切り替え' })
      const map01 = this.map01

      if (!this.$store.state.isDraw) {
        this.$store.commit('disableAllDraws')
        map01?.dragPan?.enable && map01.dragPan.enable()
        closeAllPopups()
        this.$store.state.isDraw = true
      } else {
        this.$store.state.isDraw = false
      }
      this.handlers?.finishLine?.()
    },

    // ★必ずテレポートする版
    onPrint () {
      this.usageTracker?.trackEvent('button', 'click', 'print', { text: '印刷' })
      this.handlers.handlePrint()
      this.warpToVApp()         // ← トグル禁止。常にONへ
      this.$nextTick(() => {
        this.setButtonsPrint()
      })
    },

    onLocateOnce () {
      this.usageTracker?.trackEvent('button', 'click', 'currentPosition', { text: '現在地取得' })
      this.handlers?.goToCurrentLocation?.()
    },
    onWatchToggle () {
      this.usageTracker?.trackEvent('button', 'click', 'watchPosition', { text: '現在地連続取得' })
      this.handlers?.toggleWatchPosition?.()
    },
    onShare (b) {
      this.usageTracker?.trackEvent('button', 'click', 'share', { text: '共有', source: b?.payload?.source })
      this.handlers?.share?.(b?.payload)
    },
    onHelp () {
      this.usageTracker?.trackEvent('button', 'click', 'help', { text: 'ヘルプ' })
      this.handlers?.help?.()
    },
    onAbout () {
      this.usageTracker?.trackEvent('button', 'click', 'about', { text: '情報' })
      this.$store.commit('setAboutDrawer', !this.$store.state.showAboutDrawer)
    },
    onAiHelp () {
      this.usageTracker?.trackEvent('button', 'click', 'aiHelp', { text: 'AIヘルプ' })
      this.$store.commit('setFloatingVisible', { id: 'ai-help-chat', visible: true })
    },
    onHelpExternal () {
      this.usageTracker?.trackEvent('button', 'click', 'helpExternal', { text: '逆引き辞典' })
      this.handlers?.help?.()
    },
    onAboutOH3 () {
      this.usageTracker?.trackEvent('button', 'click', 'aboutOH3', { text: 'ヘルプ' })
      window.open('https://oh3lab.jp/oh3/pages.html', '_blank')
    },
    onOpenPlan () {
      this.usageTracker?.trackEvent('button', 'click', 'openPlan', { text: 'プラン' })
      this.$store.commit('openPlanTab')
    },
    onStartTour (tourType = 'basic') {
      this.usageTracker?.trackEvent('button', 'click', 'startTour', { text: '使い方ツアー', tourType })
      this.$emit('start-tour', tourType)
    },
    onAddressSearch () {
      this.usageTracker?.trackEvent('button', 'click', 'addressSearch', { text: '住所検索' })
      // 非ログインユーザーはブロック
      if (!this.$store.state.userId) {
        this.$store.state.tokenLoginRequired = true
        return
      }
      // FloatingWindowの表示状態をトグル
      const isVisible = this.$store.state.floatingWindows['address-search']
      if (isVisible) {
        this.$store.dispatch('hideFloatingWindow', 'address-search')
      } else {
        this.$store.dispatch('showFloatingWindow', 'address-search')
      }
    },
    onGallery () {
      this.usageTracker?.trackEvent('button', 'click', 'gallery', { text: 'マップギャラリー' })
      const isVisible = this.$store.state.floatingWindows['gallery-window']
      if (isVisible) {
        this.$store.commit('setFloatingVisible', { id: 'gallery-window', visible: false })
      } else {
        this.$store.commit('setFloatingVisible', { id: 'gallery-window', visible: true })
      }
    },
    onToolbox () {
      // ツールボックスアイコンをクリックした時（メニューが開くだけなので特に何もしない）
    },
    onElevationProfile () {
      this.usageTracker?.trackEvent('button', 'click', 'elevationProfile', { text: '断面図' })
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openElevationProfileModeDialog === 'function') {
        app.openElevationProfileModeDialog()
      }
    },
    onElevationDrawLine () {
      this.usageTracker?.trackEvent('button', 'click', 'elevationDrawLine', { text: '標高図-線描画' })
      this.closeDrawUIOnToolSwitch()
      this.$store.state.elevationDrawMode = 'line'
      this.$nextTick(() => {
        if (this.handlers?.toggleLDrawLine) {
          this.handlers.toggleLDrawLine()
        } else if (this.$root?.toggleLDrawLine) {
          this.$root.toggleLDrawLine()
        } else {
          console.error('toggleLDrawLineが見つかりません')
        }
      })
    },
    onElevationDrawFree () {
      this.usageTracker?.trackEvent('button', 'click', 'elevationDrawFree', { text: '標高図-フリーハンド' })
      this.closeDrawUIOnToolSwitch()
      // フリーハンド案内ダイアログを表示してから描画開始
      if (this.$root) {
        this.$root.pendingFreehandSource = 'rightButton'
        this.$root.showFreehandInfoDialog = true
      }
    },
    onElevationFromSelected () {
      this.usageTracker?.trackEvent('button', 'click', 'elevationFromSelected', { text: '標高図-選択中の線' })
      this.closeDrawUIOnToolSwitch()
      if (this.$root?.elevationCreate) {
        this.$root.elevationCreate()
      } else {
        console.error('elevationCreateが見つかりません')
      }
    },
    onRealEstateReport () {
      this.usageTracker?.trackEvent('button', 'click', 'realEstateReport', { text: 'レポート' })
      // FloatingWindowを開く（地図クリックで地点選択）
      this.$store.commit('setFloatingVisible', {
        id: 'real-estate-report-window',
        visible: true
      })
    },
    onAiPointInfo () {
      if (!requireLogin({ title: 'AI瞬間レポート', icon: 'mdi-lightning-bolt' })) return
      this.usageTracker?.trackEvent('button', 'click', 'aiPointInfo', { text: 'AI瞬間レポート' })
      // マルチインスタンスFWを追加（座標なしで地図クリック待ち状態）
      this.$store.commit('addFWInstance', {
        type: 'ai-point-info',
        data: { lng: null, lat: null }
      })
    },
    async onJusetsuDraft () {
      if (!requireLogin({ title: '重説補助資料作成', icon: 'mdi-file-document-edit' })) return
      this.usageTracker?.trackEvent('button', 'click', 'jusetsu-draft', { text: '重説補助資料作成' })
      this.$store.commit('addFWInstance', {
        type: 'jusetsu-draft',
        data: { lng: null, lat: null }
      })
    },
    async onMaisoku () {
      if (!requireLogin({ title: '簡易マイソク', icon: 'mdi-file-image-outline' })) return
      this.usageTracker?.trackEvent('button', 'click', 'maisoku', { text: '簡易マイソク' })
      this.$store.commit('addFWInstance', {
        type: 'maisoku',
        data: { lng: null, lat: null }
      })
    },
    async onPropertyReport () {
      if (!requireLogin({ title: 'AI物件調査レポート', icon: 'mdi-home-search' })) return
      this.usageTracker?.trackEvent('button', 'click', 'ai-propertyReport', { text: 'AI物件調査レポート' })
      this.$store.commit('addFWInstance', {
        type: 'property-report',
        data: { lng: null, lat: null }
      })
    },
    async onMultiPointRanking () {
      if (!requireLogin({ title: 'AI物件調査レポート+', icon: 'mdi-home-plus' })) return
      this.usageTracker?.trackEvent('button', 'click', 'multi-point-ranking', { text: 'AI物件調査レポート+' })
      // シングルインスタンスでApp.vueの state を切り替える
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openMultiPointRanking === 'function') {
        app.openMultiPointRanking()
      }
    },
    async onChildCareReport () {
      if (!requireLogin({ title: 'AI子育てレポート', icon: 'mdi-baby-carriage' })) return
      this.usageTracker?.trackEvent('button', 'click', 'ai-childcareReport', { text: 'AI子育てレポート' })
      this.$store.commit('addFWInstance', {
        type: 'ai-childcare-report',
        data: { lng: null, lat: null }
      })
    },
    onFsInvestigation () {
      this.usageTracker?.trackEvent('button', 'click', 'fsInvestigation', { text: '土地法規等調査' })
      // モード選択ダイアログを開く
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openFsInvestigationModeDialog === 'function') {
        app.openFsInvestigationModeDialog()
      }
    },
    onSuperCrossSection () {
      this.usageTracker?.trackEvent('button', 'click', 'superCrossSection', { text: '超串刺し抽出' })
      this.$store.dispatch('toggleFloatingWindow', 'super-cross-section-window')
    },
    onSpatialQuery () {
      this.usageTracker?.trackEvent('button', 'click', 'spatialQuery', { text: '空間クエリ' })
      // モード選択ダイアログを開く
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openSpatialQueryModeDialog === 'function') {
        app.openSpatialQueryModeDialog()
      }
    },
    async onSuperPopulation () {
      if (!requireLogin({ title: 'AI人口プロファイル', icon: 'mdi-account-group' })) return
      this.usageTracker?.trackEvent('button', 'click', 'superPopulation', { text: 'AI人口プロファイル' })
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openPopulationProfileModeDialog === 'function') {
        app.openPopulationProfileModeDialog()
      }
    },
    async onAreaAnalysis () {
      if (!requireLogin({ title: 'AI防災リスク診断', icon: 'mdi-shield-alert' })) return
      this.usageTracker?.trackEvent('button', 'click', 'areaAnalysis', { text: 'AI防災リスク診断' })
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openAreaAnalysisModeDialog === 'function') {
        app.openAreaAnalysisModeDialog()
      }
    },
    onCsvJoinAnalysis () {
      this.usageTracker?.trackEvent('button', 'click', 'csvJoinAnalysis', { text: 'CSV結合分析' })
      this.$store.commit('addFWInstance', {
        type: 'csv-join-analysis',
        data: {}
      })
    },
    async onAiOsmSearch () {
      if (!requireLogin({ title: 'AI OSM検索', icon: 'mdi-magnify' })) return
      this.usageTracker?.trackEvent('button', 'click', 'aiOsmSearch', { text: 'AI OSM検索' })
      this.$store.commit('setFloatingVisible', {
        id: 'ai-osm-search-window',
        visible: true
      })
    },
    onSpreadsheetSync () {
      this.usageTracker?.trackEvent('button', 'click', 'spreadsheetSync', { text: 'スプレッドシート同期' })
      // スプレッドシート同期FloatingWindowを開く
      this.$store.commit('setFloatingVisible', {
        id: 'spreadsheet-sync-window',
        visible: true
      })
    },
    onPopularLayers () {
      this.usageTracker?.trackEvent('button', 'click', 'popularLayers', { text: '人気レイヤー' })
      // 人気レイヤーFloatingWindowを開く
      this.$store.commit('setFloatingVisible', {
        id: 'popular-layers-window',
        visible: true
      })
    },
    onSwipeCompare () {
      this.usageTracker?.trackEvent('button', 'click', 'swipeCompare', { text: 'スワイプ比較' })
      this.handlers?.toggleSwipeMode?.()
    },
    async onAiMapCompare () {
      if (!requireLogin({ title: 'AI地図チャット', icon: 'mdi-chat' })) return
      this.usageTracker?.trackEvent('button', 'click', 'aiMapCompare', { text: 'AI地図チャット' })
      this.$store.commit('setFloatingVisible', {
        id: 'map-compare-window',
        visible: true
      })
    },
    onAiEnhance () {
      this.usageTracker?.trackEvent('button', 'click', 'aiEnhance', { text: 'AI画像鮮明化' })
      if (!requireLogin({ title: 'AI画像鮮明化', icon: 'mdi-image-filter-hdr-outline' })) return
      this.handlers?.onAiEnhance?.()
    },
    onAiEnhanceSave () {
      this.usageTracker?.trackEvent('button', 'click', 'aiEnhanceSave', { text: 'AI鮮明化保存' })
      // ダイアログを開く
      this.$store.state.aiEnhanceDialogVisible = true
    },
    onTimeSlider () {
      this.usageTracker?.trackEvent('button', 'click', 'timeSlider', { text: 'タイムスライダー' })
      // タイムスライダーFloatingWindowを開く
      this.$store.commit('setFloatingVisible', {
        id: 'time-slider-window',
        visible: true
      })
    },
    onOfflineAreaManager () {
      this.usageTracker?.trackEvent('button', 'click', 'offlineAreaManager', { text: 'オフラインエリア管理' })
      // オフラインエリア管理FloatingWindowを開く
      this.$store.commit('setFloatingVisible', {
        id: 'offline-area-manager-window',
        visible: true
      })
    },
    onMagnifyToggle () {
      this.usageTracker?.trackEvent('button', 'click', 'magnify', { text: '虫眼鏡' })
      this.$store.state.isMagnifying = !this.$store.state.isMagnifying
    },
    onMonoModeToggle () {
      this.usageTracker?.trackEvent('button', 'click', 'monoMode', { text: 'モノクロ' })
      const newVal = !this.$store.state.isSketchMode
      this.$store.state.isSketchMode = newVal
      // mapコンテナにCSSクラスを付け外し
      for (const name of ['map01', 'map02', 'map03', 'map04']) {
        const map = this.$store.state[name]
        if (map) {
          const c = map.getContainer()
          if (c) c.classList.toggle('oh-sketch-mode', newVal)
        }
      }
    },
    onIsochrone () {
      this.usageTracker?.trackEvent('button', 'click', 'isochrone', { text: '到達圏' })
      this.$store.dispatch('showFloatingWindow', 'isochrone-window')
    },
    onSimaQuick () {
      this.usageTracker?.trackEvent('button', 'click', 'sima-quick', { text: '簡単SIMA' })
      this.$store.dispatch('showFloatingWindow', 'sima-quick-window')
    },
    onWatershed () {
      this.usageTracker?.trackEvent('button', 'click', 'ai-watershed', { text: '流域計算' })
      // 流域計算FloatingWindowを開く
      this.$store.dispatch('showFloatingWindow', 'watershed-window')
    },
    onGroupManage () {
      this.usageTracker?.trackEvent('button', 'click', 'groupManage', { text: 'グループ管理' })
      if (!requireLogin({ title: 'グループチャット', icon: 'mdi-account-group' })) return
      this.$store.commit('setFloatingVisible', { id: 'group-manage-window', visible: true })
    },
    onUpload () {
      this.usageTracker?.trackEvent('button', 'click', 'upload', { text: '各種アップロード' })
      // 各種アップロード機能を開く
      this.$store.state.isMenu = true
      this.$store.commit('openFileDropFlow', { files: [], mode: 'user-select' })
    },
    onPhotoMemo () {
      this.usageTracker?.trackEvent('button', 'click', 'photoMemo', { text: 'フィールドノート' })
      if (!requireLogin({ title: 'フィールドノート', icon: 'mdi-camera-plus' })) return
      this.$store.dispatch('showFloatingWindow', 'photo-memo-upload')
    },
    onHillshadeSettings () {
      this.usageTracker?.trackEvent('button', 'click', 'hillshadeSettings', { text: '陰影設定' })
      // 陰影設定ダイアログを開く
      this.handlers?.openHillshadeDialog?.()
    },
    onDrawOpen () {
      this.usageTracker?.trackEvent('button', 'click', 'drawOpen', { text: 'ドロー' })
      this.handlers?.drawOpen?.()
    },
    onDrawListOpen () {
      this.usageTracker?.trackEvent('button', 'click', 'drawListOpen', { text: 'ドローリスト' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.drawListOpen?.()
    },

    // 左列：描画ツール
    // 描画ツール切り替え時にDrawDrawerとDrawFWを閉じる共通処理
    closeDrawUIOnToolSwitch () {
      this.$store.commit('setDrawDrawer', false)
      this.$store.commit('setFloatingVisible', { id: 'draw-floating-window', visible: false })
      this.$store.commit('setCurrentDrawFeature', null)
      // 複製モードも終了
      this.$store.commit('setDrawDuplicate', false)
      this.$store.commit('setDuplicateSourceFeature', null)
      // 移動・編集モードも終了
      this.$store.state.editEnabled = false
      // 確定・1点戻す・キャンセルボタンも閉じる
      this.$store.state.showDrawConfrim = false
      // スケッチモードも終了
      this.handlers?.closeFreehandCanvas?.()
      // 選択レイヤー（ハイライト）も解除
      const map = this.$store.state.map01
      if (map) {
        clearSelectedFeature(map)
      }
    },
    onToggleDrawPoint ()    {
      this.usageTracker?.trackEvent('button', 'click', 'drawPoint', { text: '点' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleDrawPoint?.()
    },
    onGpsPhotoImport () {
      this.usageTracker?.trackEvent('button', 'click', 'gpsPhotoImport', { text: 'GPS写真追加' })
      this.closeDrawUIOnToolSwitch()
      // 非表示のfile inputをクリックしてファイル選択を開く
      this.$refs.gpsPhotoInput?.click()
    },
    onGpsPhotoSelected (event) {
      const files = Array.from(event.target.files || [])
      if (files.length === 0) return

      // App.vueのhandleGpsPhotosImportを呼び出す
      // handlersを通じて呼び出すか、親コンポーネントから直接呼び出す
      if (this.handlers?.handleGpsPhotosImport) {
        this.handlers.handleGpsPhotosImport(files, this.showGpsPhotoError.bind(this))
      } else if (this.$parent?.handleGpsPhotosImport) {
        this.$parent.handleGpsPhotosImport(files, this.showGpsPhotoError.bind(this))
      } else {
        console.error('handleGpsPhotosImport is not available')
      }

      // ファイル入力をリセット（同じファイルを再度選択できるように）
      event.target.value = ''
    },
    showGpsPhotoError ({ title, message }) {
      // MessageDialogを使ってエラーを表示
      this.gpsPhotoErrorTitle = title
      this.gpsPhotoErrorMessage = message
      this.gpsPhotoErrorDialogOpen = true
    },
    onToggleDrawCircle ()   {
      this.usageTracker?.trackEvent('button', 'click', 'drawCircle', { text: '円' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleDrawCircle?.()
    },
    onToggleLDrawLine ()    {
      this.usageTracker?.trackEvent('button', 'click', 'drawLine', { text: '線' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleLDrawLine?.()
    },
    onToggleLDrawPolygon () {
      this.usageTracker?.trackEvent('button', 'click', 'drawPolygon', { text: '多角形' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleLDrawPolygon?.()
    },
    onToggleLDrawFree ()    {
      this.usageTracker?.trackEvent('button', 'click', 'drawFree', { text: '自由描画' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleLDrawFree?.()
    },
    onToggleFreehandCanvas () {
      this.usageTracker?.trackEvent('button', 'click', 'freehandCanvas', { text: 'スケッチ' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleFreehandCanvas?.()
    },
    onToggleDrawText ()     {
      this.usageTracker?.trackEvent('button', 'click', 'drawText', { text: 'テキスト' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleDrawText?.()
    },
    onToggleDrawLasso ()    {
      this.usageTracker?.trackEvent('button', 'click', 'drawLasso', { text: '投げ縄' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleDrawLasso?.()
    },
    onToggleEditEnabled ()  {
      this.usageTracker?.trackEvent('button', 'click', 'drawEdit', { text: '編集' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.toggleEditEnabled?.()
    },
    onUndo ()               {
      if (this.disableUndoRedo) return
      this.usageTracker?.trackEvent('button', 'click', 'drawUndo', { text: '元に戻す' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.undo?.()
    },
    onRedo ()               {
      if (this.disableUndoRedo) return
      this.usageTracker?.trackEvent('button', 'click', 'drawRedo', { text: 'やり直す' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.redo?.()
    },
    onDrawVisibility ()     {
      this.usageTracker?.trackEvent('button', 'click', 'drawVisibility', { text: '表示切替' })
      // 移動・編集モードを終了し、関連UIを閉じる
      this.closeDrawUIOnToolSwitch()
      this.$store.commit('setFloatingVisible', { id: 'draw-visibility-window', visible: true })
    },
    onDrawHelp ()           {
      this.usageTracker?.trackEvent('button', 'click', 'drawHelp', { text: 'ヘルプ' })
      this.closeDrawUIOnToolSwitch()
      this.$store.commit('setFloatingVisible', { id: 'draw-help-window', visible: true })
    },
    onDrawConfig ()         {
      this.usageTracker?.trackEvent('button', 'click', 'drawConfig', { text: '設定' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.drawConfig?.()
    },
    onDrawShare ()          {
      this.usageTracker?.trackEvent('button', 'click', 'cloudDraw', { text: 'マイドロー' })
      this.closeDrawUIOnToolSwitch()
      if (!requireLogin({ title: 'マイドロー', icon: 'mdi-cloud-lock' })) return
      this.handlers?.drawShare?.()
    },
    onDialogForDlOpen ()    {
      this.usageTracker?.trackEvent('button', 'click', 'drawDl', { text: 'DL' })
      this.closeDrawUIOnToolSwitch()
      this.handlers?.dialogForDlOpen?.()
    },
    onDeleteAllForDraw ()   {
      this.usageTracker?.trackEvent('button', 'click', 'drawDeleteAll', { text: '全削除' })
      // 共有ドロー（みんなで編集）の場合は削除不可（自分だけのドローは許可）
      if (this.$store.state.isUsingServerGeojson && this.$store.state.isEditable) {
        this.$store.dispatch('messageDialog/open', {
          id: 'draw-delete-all-error',
          title: '削除できません',
          contentHtml: '共有ドロー（みんなで編集）モードでは、全削除はできません。',
        })
        return
      }
      this.closeDrawUIOnToolSwitch()
      this.handlers?.deleteAllforDraw?.()
    },
    onDrawClose ()          {
      this.usageTracker?.trackEvent('button', 'click', 'drawClose', { text: '閉じる' })
      this.closeDrawUIOnToolSwitch()
      // 現在地追跡を停止してマーカーを削除
      this.handlers?.toggleWatchPosition?.(null, true)
      this.$store.state.isDraw = false
    },

    onPrintBack () {
      this.usageTracker?.trackEvent('button', 'click', 'printBack', { text: '印刷から戻る' })
      this.handlers.handlePrint(true)
      this.warpBack()          // ← 必ずテレポート解除
      this.setButtonsDefault()
    },
    onPrintExec ()   {
      this.usageTracker?.trackEvent('button', 'click', 'printExec', { text: '印刷実行' })
      this.handlers.print()
    },
    onPrintConfig () {
      this.usageTracker?.trackEvent('button', 'click', 'printConfig', { text: '印刷設定' })
      this.handlers.drawConfig()
    },
    onQrCode () {
      this.usageTracker?.trackEvent('button', 'click', 'qrcode', { text: 'QRコード貼り付け' })
      this.handlers.openQrCodeWindow()
    },
    onPdfDl ()       {
      this.usageTracker?.trackEvent('button', 'click', 'pdfDl', { text: 'PDF' })
      this.handlers.pdfDl()
    },
    onPngDl0 ()      {
      this.usageTracker?.trackEvent('button', 'click', 'pngDl', { text: 'PNG' })
      this.handlers.pngDl0()
    },

    // ===== Teleport制御を堅牢化 =====
    ensureTeleportTarget () {
      const el = document.querySelector(this.teleportTargetSel) || document.body
      if (this.teleportTargetEl !== el) this.teleportTargetEl = el
      return !!el
    },
    warpToVApp () {
      // 1回目の解決
      this.ensureTeleportTarget()
      this.teleporting = !!this.teleportTargetEl

      // レイアウト確定後に再確認（遅延生成への保険）
      this.$nextTick(() => {
        if (!this.teleportTargetEl) {
          this.ensureTeleportTarget()
        }
        if (!this.teleporting && this.teleportTargetEl) {
          this.teleporting = true
        }
      })
    },
    warpBack () { this.teleporting = false },
    // 互換用（他所から呼ばれても壊さないために残すが、onPrintでは使わない）
    toggleWarp () { this.teleporting = !this.teleporting },
  }
}
</script>

<style scoped>
.draw-status-pill {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1002; /* FreehandCanvas(1000)より上に */
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: var(--oh3-radius-full);
  color: var(--oh3-color-black);
  background: var(--oh3-color-overlay-white-90);
  border: 1px solid var(--oh3-color-border-default);
  font-size: 13px;
  box-shadow: var(--oh3-shadow-sm);
}
.draw-status-pill .status-dot {
  width: 10px;
  height: 10px;
  border-radius: var(--oh3-radius-full);
  background: currentColor;
}
@media (max-width: 500px) {
  .draw-status-pill {
    left: 50%;
    transform: translateX(-50%);
    top: 58px; /* アイコン群の少し下に配置 */
    max-width: 90%;
    justify-content: center;
  }
}

/* アニメーション定義 */
@keyframes slideInFromRight {
  0% {
    opacity: 0;
    transform: translateX(50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulseGlow {
  0%, 100% {
    box-shadow: 0 0 5px rgba(var(--v-theme-primary), 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(var(--v-theme-primary), 0.6);
  }
}

.icons-div-base{
  gap: 12px;
  position: absolute;
  top:10px;
  right:10px;   /* 右端 */
  z-index:1005;  /* FreehandCanvas(1000)より上に */
  animation: slideInFromRight 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}
/* 右列のボタンのテキストを太く */
.icons-div-base :deep(.v-btn span) {
  font-weight: 700;
}

/* 右列の各ボタンにスタッガーアニメーション */
.icons-div-base :deep(.v-btn) {
  animation: slideInFromRight 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) backwards;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.icons-div-base :deep(.v-btn:nth-child(1)) { animation-delay: 0.05s; }
.icons-div-base :deep(.v-btn:nth-child(2)) { animation-delay: 0.1s; }
.icons-div-base :deep(.v-btn:nth-child(3)) { animation-delay: 0.15s; }
.icons-div-base :deep(.v-btn:nth-child(4)) { animation-delay: 0.2s; }
.icons-div-base :deep(.v-btn:nth-child(5)) { animation-delay: 0.25s; }
.icons-div-base :deep(.v-btn:nth-child(6)) { animation-delay: 0.3s; }
.icons-div-base :deep(.v-btn:nth-child(7)) { animation-delay: 0.35s; }
.icons-div-base :deep(.v-btn:nth-child(8)) { animation-delay: 0.4s; }

/* ホバー時のバウンスエフェクト */
.icons-div-base :deep(.v-btn:hover) {
  transform: scale(1.15) translateY(-2px);
  box-shadow: 0 4px 12px var(--oh3-color-overlay-30);
}

.icons2-div-base{
  gap: 12px;
  position: absolute;
  top:10px;
  right:70px;   /* 通常は右列の左隣。小画面＋描画時は JSで10pxに上書き。ドローリスト開時は320px */
  z-index:1005;  /* FreehandCanvas(1000)より上に */
  max-height: 70vh;  /* 画面高さの70%以下に制限 */
  animation: slideInFromLeft 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  transition: right 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
/* 左列の描画ボタンのテキストを太く */
.icons2-div-base :deep(.v-btn span) {
  font-weight: 700;
}

/* 左列（ドロー）の各ボタンにスタッガーアニメーション */
.icons2-div-base :deep(.v-btn) {
  animation: slideInFromLeft 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) backwards;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.icons2-div-base :deep(.v-btn:nth-child(1)) { animation-delay: 0.05s; }
.icons2-div-base :deep(.v-btn:nth-child(2)) { animation-delay: 0.1s; }
.icons2-div-base :deep(.v-btn:nth-child(3)) { animation-delay: 0.15s; }
.icons2-div-base :deep(.v-btn:nth-child(4)) { animation-delay: 0.2s; }
.icons2-div-base :deep(.v-btn:nth-child(5)) { animation-delay: 0.25s; }
.icons2-div-base :deep(.v-btn:nth-child(6)) { animation-delay: 0.3s; }
.icons2-div-base :deep(.v-btn:nth-child(7)) { animation-delay: 0.35s; }
.icons2-div-base :deep(.v-btn:nth-child(8)) { animation-delay: 0.4s; }

/* ホバー時のバウンスエフェクト */
.icons2-div-base :deep(.v-btn:hover) {
  transform: scale(1.15) translateY(-2px);
  box-shadow: 0 4px 12px var(--oh3-color-overlay-30);
}

/* 画面高さに応じてgapを調整（70%を超えないように） */
@media (max-height: 800px) {
  .icons2-div-base { gap: 8px; }
}
@media (max-height: 700px) {
  .icons2-div-base { gap: 6px; }
}
@media (max-height: 600px) {
  .icons2-div-base { gap: 4px; }
}
@media (max-height: 500px) {
  .icons2-div-base { gap: 2px; }
}

/* 画面幅400px以下の時、アイコン集を下に1個分ずらす */
@media (max-width: 400px) {
  .icons-div-base {
    top: 54px; /* アイコン1個分（32px + gap 12px + 余裕10px）ずらす */
  }
  .icons2-div-base {
    top: 54px; /* 同様にずらす */
  }
}

@media print {
  .icons-div-base { display: none !important; }
  .icons2-div-base { display: none !important; }
}

/* ドローツールメニューのスタイル - 視認性重視 */
.draw-tool-menu {
  min-width: 200px;
  background: rgb(var(--v-theme-primary)) !important;
  filter: brightness(0.85);
  border-radius: var(--oh3-radius-lg) !important;
  box-shadow: 0 4px 16px var(--oh3-color-overlay-30) !important;
  padding: 6px !important;
  animation: menuSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* メニュー表示アニメーション */
@keyframes menuSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.draw-tool-menu .v-list-item {
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  border-radius: var(--oh3-radius-md);
  margin: 3px 0;
  background: var(--oh3-color-overlay-10);
  animation: menuItemSlideIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1) backwards;
}

/* メニュー項目のスタッガーアニメーション */
@keyframes menuItemSlideIn {
  0% {
    opacity: 0;
    transform: translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.draw-tool-menu .v-list-item:nth-child(1) { animation-delay: 0.02s; }
.draw-tool-menu .v-list-item:nth-child(2) { animation-delay: 0.04s; }
.draw-tool-menu .v-list-item:nth-child(3) { animation-delay: 0.06s; }
.draw-tool-menu .v-list-item:nth-child(4) { animation-delay: 0.08s; }
.draw-tool-menu .v-list-item:nth-child(5) { animation-delay: 0.1s; }
.draw-tool-menu .v-list-item:nth-child(6) { animation-delay: 0.12s; }
.draw-tool-menu .v-list-item:nth-child(7) { animation-delay: 0.14s; }
.draw-tool-menu .v-list-item:nth-child(8) { animation-delay: 0.16s; }

/* サブヘッダーのアニメーション */
.draw-tool-menu .v-list-subheader {
  animation: menuItemSlideIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) backwards;
  animation-delay: 0s;
}

/* 区切り線のアニメーション */
.draw-tool-menu .v-divider {
  animation: dividerExpand 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes dividerExpand {
  0% {
    transform: scaleX(0);
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    opacity: 1;
  }
}

.draw-tool-menu .v-list-item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(5px) scale(1.03);
  box-shadow: 0 2px 8px var(--oh3-color-overlay-20);
}

.draw-tool-menu .v-list-item:active {
  transform: translateX(3px) scale(0.98);
  background: rgba(255, 255, 255, 0.1);
}

.draw-tool-menu .v-list-item-title {
  font-size: var(--oh3-font-size-base);
  font-weight: 700;
  color: #ffffff !important;
  letter-spacing: 0.3px;
}

/* NEWバッジ */
.new-badge {
  display: inline-block;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  font-size: var(--oh3-font-size-xs);
  font-weight: 800;
  padding: 2px 6px;
  border-radius: var(--oh3-radius-base);
  margin-right: 6px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(238, 90, 36, 0.4);
  animation: newBadgePulse 2s ease-in-out infinite;
}

@keyframes newBadgePulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 2px 4px rgba(238, 90, 36, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 3px 8px rgba(238, 90, 36, 0.6);
  }
}

/* アイコンを完全な白色で統一 */
.draw-tool-menu .v-icon {
  color: #ffffff !important;
  opacity: 1;
}

/* ホバー時にさらに強調 */
.draw-tool-menu .v-list-item:hover .v-icon {
  filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.5));
}

/* アクティブ状態のアイテムを強調 */
.draw-tool-menu .v-list-item.item-active {
  background: rgba(76, 175, 80, 0.3) !important;
  animation: itemActivePulse 2s ease-in-out infinite;
}

@keyframes itemActivePulse {
  0%, 100% {
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
    background: rgba(76, 175, 80, 0.3) !important;
  }
  50% {
    box-shadow: 0 0 15px rgba(76, 175, 80, 0.8);
    background: rgba(76, 175, 80, 0.4) !important;
  }
}

.draw-tool-menu .v-list-item.item-active .v-icon {
  filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.8));
  animation: iconGlow 2s ease-in-out infinite;
}

@keyframes iconGlow {
  0%, 100% {
    filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.8));
  }
  50% {
    filter: drop-shadow(0 0 8px rgba(76, 175, 80, 1));
  }
}

/* Undo/Redoのバッジをクリックスルー */
.icons2-div-base :deep(.v-badge__badge) {
  pointer-events: none;
}

/* 標高図作成のサブメニュー項目にインデントを追加 */
.draw-tool-menu .indented-menu-item {
  padding-left: 40px !important;
}
</style>
